var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "header" }, [
      _c("i", { staticClass: "fas fa-align-left" }),
      _vm._v(" "),
      _c("h5", { staticClass: "d-inline mx-2" }, [
        _vm._v(" " + _vm._s(_vm.$t("txtDescription")) + " ")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.editDescription,
              expression: "editDescription"
            },
            { name: "autogrow", rawName: "v-autogrow" },
            {
              name: "observe-visibility",
              rawName: "v-observe-visibility",
              value: {
                callback: _vm.onDescBoxVisibilityChange,
                throttle: 300,
                throttleOptions: {
                  leading: "visible"
                }
              },
              expression:
                "{\n                      callback: onDescBoxVisibilityChange,\n                      throttle: 300,\n                      throttleOptions: {\n                        leading: 'visible',\n                      },\n                    }"
            }
          ],
          ref: "descBox",
          staticClass: "add_comment mb-1",
          attrs: {
            id: "detailsbox_" + _vm.card.id,
            rows: "1",
            readonly: _vm.readonly || _vm.lockeddown,
            placeholder: _vm.$t("txtAddDetails")
          },
          domProps: { value: _vm.editDescription },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.editDescription = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("TextSuggest", {
          attrs: {
            textBoxId: "detailsbox_" + _vm.card.id,
            suggestions: _vm.userEmails,
            trigger: "@"
          }
        }),
        _vm._v(" "),
        !_vm.readonly && !_vm.lockeddown
          ? _c(
              "button",
              {
                staticClass: "btn btn-default btn-outline-secondary",
                on: { click: _vm.updateDescription }
              },
              [_vm._v("\n      Update\n    ")]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }